/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
import Impetus from 'impetus';
import throttle from 'lodash/throttle';

export default class Scrollesel {
  constructor(customOptions) {
    const defaultOptions = {
      element: '.scrollesel',

      toShow: window.innerWidth < 768 ? 1.5 : 3.5,
      scrollIncrement: 12,
      friction: 0.1,

      trackMargin: 50,
      itemMargin: 20,

      initialOffset: 0,
    };

    this.options = {
      ...defaultOptions,
      ...customOptions,
    };

    this.defineDefaults();

    this.getElements();
    this.bindEvents();

    this.initScrollesel();
    this.initScrolleselDrag();

    this.animLoop();

    if (!this.draggable) this.scrollesel.style.pointerEvents = 'none';
  }

  defineDefaults() {
    this.currentScrollY = 0;

    this.positions = {
      scroll: 0,
      drag: 0,
    };

    this.positionFinal = this.positions.scroll + this.positions.drag;
  }

  getElements() {
    this.scrollesel = typeof this.options.element === 'string'
      ? document.querySelector(this.options.element)
      : this.options.element;

    this.track = this.scrollesel.querySelector('.scrollesel--track');
    this.items = this.scrollesel.querySelectorAll('.scrollesel--track > *');
  }

  bindEvents() {
    window.addEventListener('resize', throttle(this.initScrollesel.bind(this), 200));
    window.addEventListener('scroll', throttle(this.updateScrollValue.bind(this), 0));
  }

  /** *******************************************
   * Init Scrollesel
   * **** */
  initScrollesel() {
    this.calculateScrolleselStyles();
    this.setScrolleselStyles();
  }

  calculateScrolleselStyles() {
    this.scrolleselStyles = {
      trackWidth:
        (window.innerWidth / this.options.toShow) * this.items.length
        + this.options.itemMargin * (this.items.length - 1) * 2,
      trackMargin: this.options.trackMargin,

      itemWidth: window.innerWidth / this.options.toShow,
      itemMargin: this.options.itemMargin,
    };
  }

  setScrolleselStyles() {
    this.items.forEach((item, index) => {
      item.style.width = `${this.scrolleselStyles.itemWidth}px`;
      item.style.marginLeft = `${this.scrolleselStyles.itemMargin}px`;
      item.style.marginRight = `${this.scrolleselStyles.itemMargin}px`;

      if (index === 0) item.style.marginLeft = '';
      if (index === this.items.length - 1) item.style.marginRight = '';
    });

    this.track.style.width = `${this.scrolleselStyles.trackWidth}px`;
    this.track.style.margin = `0 ${this.scrolleselStyles.trackMargin}px`;
  }

  /** *******************************************
   * Init Scrollesel mouse drag powered by Impetus.js
   * **** */
  initScrolleselDrag() {
    this.impetus = new Impetus({
      source: this.track,
      boundX: [this.getScrolleselBounds().min, this.getScrolleselBounds().max],
      update: (x) => {
        this.positions.drag = x;
      },
    });

    this.positions.drag = -this.options.initialOffset;
  }

  /** *******************************************
   * requestAnimationFrame loop
   * **** */
  animLoop() {
    this.updateValues();
    this.updateBounds();
    this.updateScrolleselPosition();

    window.requestAnimationFrame(this.animLoop.bind(this));
  }

  updateValues() {
    const endValue = this.positions.drag + this.positions.scroll;

    this.positionFinal = parseInt(
      this.lerp(this.positionFinal, endValue, this.options.friction),
      10,
    );
  }

  updateScrollValue() {
    const pos = window.scrollY || window.pageYOffset;
    const direction = this.currentScrollY - pos > 0 ? 'down' : 'up';
    const incrementValue = this.currentScrollY - pos > 0 ? this.options.scrollIncrement : -this.options.scrollIncrement;

    if (
      !this.isOutOfBounds()
      || (this.isOutOfBounds() === 'max' && direction === 'up')
      || (this.isOutOfBounds() === 'min' && direction === 'down')
    ) {
      this.positions.scroll += incrementValue;
    }

    this.currentScrollY = pos;
  }

  updateBounds() {
    this.impetus.setBoundX([
      this.getScrolleselBounds().min - this.positions.scroll,
      this.getScrolleselBounds().max - this.positions.scroll,
    ]);
  }

  updateScrolleselPosition() {
    this.setTransform(this.track, `translate3d(${this.positionFinal}px, 0, 0)`);
  }

  getScrolleselBounds() {
    const min = -(
      this.scrolleselStyles.trackWidth
      + this.options.trackMargin * 2
      + 30 * 2
      - window.innerWidth
    );
    const max = 0;

    return { min, max };
  }

  isOutOfBounds() {
    if (this.positionFinal >= this.getScrolleselBounds().max) {
      return 'max';
    }
    if (this.positionFinal <= this.getScrolleselBounds().min) {
      return 'min';
    }
    return false;
  }

  /** *******************************************
   * Sets 'transform' CSS property
   * **** */
  setTransform(elem, value) {
    elem.style.webKitTransform = value;
    elem.style.transform = value;
  }

  /** *******************************************
   * Lerp Function
   * **** */
  lerp(start, end, amount) {
    return (1 - amount) * start + amount * end;
  }
}
